module.exports = __webpack_public_path__ + "img/rotationImgFour.b623aa79.png";